import api from '@/apis'

export default {
  state: {
    loading: false,
    datepicker: {
      date: [
        new Date(Date.now() - 604800000 - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)
      ]
    },
    group_id: null,
    user_id: null,
    group_list: [],
    user_list: [],
    line_chart: {}
  },
  mutations: {
    SET_DASHBOARD_LOADING(state, payload) {
      state.loading = payload
    },
    SET_DASHBOARD_DATEPICKER_DATE(state, payload) {
      state.datepicker.date = payload
    },
    SET_DASHBOARD_GROUP_ID(state, payload) {
      state.group_id = payload
    },
    SET_DASHBOARD_USER_ID(state, payload) {
      state.user_id = payload
    },
    SET_DASHBOARD_GROUP_LIST(state, payload) {
      state.group_list = payload
    },
    SET_DASHBOARD_USER_LIST(state, payload) {
      state.user_list = payload
    },
    SET_DASHBOARD_LINE_CHART(state, payload) {
      state.line_chart = payload
    }
  },
  actions: {
    async initDashboard({ commit, dispatch }) {
      try {
        commit('SET_DASHBOARD_LOADING', true)
        const [group, user] = await Promise.all([api.getGroupList(), api.getUserList()])
        if (group.data.success) {
          commit('SET_DASHBOARD_GROUP_LIST', group.data.data)
          dispatch('fetchDashboardSummary')
        } else throw Error(group.data.message)
        if (user.data.success) {
          commit('SET_DASHBOARD_USER_LIST', user.data.data)
        } else throw Error(user.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_DASHBOARD_LOADING', false)
      }
    },
    async fetchDashboardSummary({ state, commit }) {
      try {
        commit('SET_DASHBOARD_LOADING', true)
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: 'Loading', loading: true })

        const [date_from, date_to] = state.datepicker.date
        let group_id = state.group_id
        let group_ids = null
        if (state.group_id === null) {
          let all_group_ids = ''
          state.group_list.forEach((group) => {
            if (group.id) {
              if (all_group_ids !== '') all_group_ids = all_group_ids + ','
              all_group_ids = all_group_ids + group.id
            }
          })
          group_ids = all_group_ids
        }

        const response = await api.getDashboard({ date_from: date_from, date_to: date_to, group_id: group_id, group_ids: group_ids, user_id: state.user_id })

        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: response.data.message, icon: 'check', timeout: '2000' })
          commit('SET_DASHBOARD_LINE_CHART', response.data.data)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_DASHBOARD_LOADING', false)
      }
    }
  }
}
